import React from 'react';
import AboutUsImg from '../../Assets/images/AboutUs-unsplash_JaoVGh5aJ3E.png';
import { FaCogs, FaChartLine, FaLightbulb, FaShieldAlt } from 'react-icons/fa';
import BostIcon from '../../Assets/images/BostIcon.png';
import IdeaIcon from '../../Assets/images/IdeaIcon.png';
// import AboutUsText from './components/About/AboutUsText';
// import About from './About';
import AboutUsText from './AboutUsText';
import Contact from '../../Components/Contact/Contact';
import { useNavigate } from 'react-router-dom';
const About = () => {
  const navigate = useNavigate();
  const handleSmoothScroll = e => {
    e.preventDefault(); // Prevent default anchor link behavior
    const targetId = e.currentTarget.getAttribute('href').substring(1); // Get the target ID without '#'
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Custom smooth scroll logic
      const duration = 1500; // Time in milliseconds for slower scrolling (1.5 seconds)
      const targetPosition = targetElement.getBoundingClientRect().top;
      const startPosition = window.pageYOffset;
      const distance = targetPosition;
      let startTime = null;

      const animation = currentTime => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);

        if (timeElapsed < duration) requestAnimationFrame(animation);
      };

      const ease = (t, b, c, d) => {
        // Easing function for smooth effect (easeInOutQuad)
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };

      requestAnimationFrame(animation);
    }
  };
  const handleContuctUsClick = () => {
    navigate('/contactUs');
    window.scrollTo(0, 0);
  }
  return (
    <>
      <div id="about" className="w-full bg-gray-100">
        <div className="mx-auto px-10 md:py-28 py-24 md:mt-10 mt-16 flex flex-col lg:flex-row items-center justify-between -mb-16">
          {/* Left Section: Text and Button */}
          <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-xl md:text-3xl font-bold text-gray-800 md:mb-6 mb-1 md:pt-0 pt-4">
              Simplifying Your Path to Winning Environmental Tenders
            </h1>
            <p className="text-gray-600 md:text-sm text-xs md:mb-6 mb-4">
              Welcome to Tender Wise, your go-to platform for accessing and
              managing private environmental tenders in Bangladesh. We
              streamline the tender process, offering easy access to published
              tenders, product documents, and bidding details.
            </p>
            <a
              onClick={handleSmoothScroll}
              href="#aboutUsText"
              className=" text-headerBtn md:px-6 px-4 md:py-3 py-1 rounded-2xl border-2 border-headerBtn hover:bg-btnHover hover:text-gray-200 "
            >
              Learn More
            </a>

            <div className="md:mt-6 md:flex hidden md:pt-6 pt-4 md:gap-8 gap-2 md:h-36 h-auto  ">
              <div className="flex bg-AboutUsBg shadow-xl hover:bg-slate-300 gap-4 rounded-xl p-6 ">
                <div className="md:flex md:items-center  md:justify-center md:mb-4 ">
                  <img
                    src={BostIcon}
                    alt="BostIcon"
                    className="md:h-14 md:w-20 h-auto w-8 "
                  />
                </div>
                <div className="flex flex-col items-left justify-center ">
                  <h3 className="md:text-sm font-semibold text-gray-800 md:mb-2 mb-1 md:mt-0 -mt-6">
                    See bidding details.
                  </h3>
                  <p className="text-gray-600 text-xs md:mb-4 -mb-6 ">
                    Quick and straightforward online form submission.
                  </p>
                </div>
              </div>

              <div className="flex bg-AboutUsBg hover:bg-slate-300 shadow-xl gap-4 rounded-xl p-6">
                <div className="flex items-center justify-center mb-4">
                  <img
                    src={IdeaIcon}
                    alt="IdeaIcon"
                    className="md:h-14 md:w-20 h-auto w-8"
                  />
                </div>
                <div className="flex flex-col items-left justify-center">
                  <h3 className="md:text-sm font-semibold text-gray-800 md:mb-2 mb-1 md:mt-0 ">
                    View product documents.
                  </h3>
                  <p className="text-gray-600 text-xs md:text-left text-center md:mb-4 -mb-2">
                    Tailored loan options and competitive rates to fit your
                    needs.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section: Image */}
          <div className="lg:w-1/2 md:pl-20">
            <img
              src={AboutUsImg}
              alt="Hero Image"
              className="w-full md:w-4/5 h-auto"
            />
            <div className="bg-white shadow-2xl rounded-2xl p-11 h-36 w-56 mx-auto -translate-y-2/4 items-center justify-center ">
              <h2 className="text-black pb-2">Looking for help?</h2>
              <div className="pb-0 ml-2 mt-2">
                <button
                  onClick={handleContuctUsClick}
                  className=" text-headerBtn px-2 py-1 rounded-2xl border-2 border-headerBtn hover:bg-headerBtn hover:text-gray-200 "
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
        <AboutUsText />
      </div>
      <Contact />
    </>
  );
};

export default About;
